/**
 * Free Download Handler
 *
 * Handles the AJAX-based free download flow for membership users.
 * Creates a silent $0 order and triggers the protected download URL.
 *
 * @package bricks-arival
 * @since 1.0.0
 */

(function($) {
	'use strict';

	/**
	 * Free Download Handler Class
	 */
	var FreeDownloadHandler = {
		
		/**
		 * Configuration from localized script
		 */
		config: {
			ajaxUrl: '',
			nonce: '',
			productId: 0,
			i18n: {
				downloading: 'Processing...',
				error: 'An error occurred. Please try again.',
				downloadFailed: 'We could not deliver that file. Please try again, or contact us if it keeps happening.',
				downloadNow: 'Download Now'
			}
		},

		/**
		 * Initialize the handler
		 */
		init: function() {
			// Get configuration from localized script.
			// Deep merge: i18n is a nested object and more than one template localises
			// this handle, so a shallow merge would replace the whole i18n block with
			// whichever set that template happens to define and render "undefined" to
			// the customer for any key it omits.
			if (typeof arivalFreeDownload !== 'undefined') {
				this.config = $.extend(true, {}, this.config, arivalFreeDownload);
			}

			// Bind events
			this.bindEvents();
		},

		/**
		 * Bind click events to download buttons
		 */
		bindEvents: function() {
			var self = this;

			// Handle click on free download buttons
			$(document).on('click', '.arival-free-download-btn', function(e) {
				e.preventDefault();
				
				var $button = $(this);
				var productId = $button.data('product-id') || self.config.productId;
				
				if (!productId) {
					console.error('No product ID found');
					return;
				}

				self.processDownload($button, productId);
			});
		},

		/**
		 * Process the download request
		 *
		 * @param {jQuery} $button The clicked button
		 * @param {number} productId The product ID
		 */
		processDownload: function($button, productId) {
			var self = this;

			// Prevent double-clicks
			if ($button.hasClass('is-loading')) {
				return;
			}

			// Show loading state
			this.setLoadingState($button, true);

			// Make AJAX request
			$.ajax({
				url: this.config.ajaxUrl,
				type: 'POST',
				data: {
					action: 'arival_free_download',
					nonce: this.config.nonce,
					product_id: productId
				},
				success: function(response) {
					if (response.success && response.data.download_url) {
						// Only claim the download started once the browser has actually
						// taken the file. The alert used to fire unconditionally, right
						// after appending the iframe, so a 404 still told the customer
						// their download had begun (UAT, Flow 5).
						self.triggerDownload(response.data.download_url, function(succeeded) {
							if (succeeded) {
								self.showSuccessAlert();
							} else {
								self.showError(self.config.i18n.downloadFailed);
							}

							self.setLoadingState($button, false);
						});
					} else {
						// Show error message
						var message = response.data && response.data.message 
							? response.data.message 
							: self.config.i18n.error;
						
						self.showError(message);
						self.setLoadingState($button, false);
						
						// If redirect URL provided (e.g., login), redirect
						if (response.data && response.data.redirect) {
							setTimeout(function() {
								window.location.href = response.data.redirect;
							}, 2000);
						}
					}
				},
				error: function(xhr, status, error) {
					console.error('Download AJAX error:', error);
					self.showError(self.config.i18n.error);
					self.setLoadingState($button, false);
				}
			});
		},

		/**
		 * Set button loading state
		 *
		 * @param {jQuery} $button The button element
		 * @param {boolean} isLoading Loading state
		 */
		setLoadingState: function($button, isLoading) {
			if (isLoading) {
				$button.addClass('is-loading').prop('disabled', true);
			} else {
				$button.removeClass('is-loading').prop('disabled', false);
			}
		},

		/**
		 * Trigger the actual file download, reporting whether it worked.
		 *
		 * A genuine file response carries Content-Disposition: attachment — the browser
		 * hands it to the download manager and the iframe never navigates, so no load
		 * event fires. An error response is an HTML document, which the iframe renders
		 * and which does fire load. So a rendered page means the download failed.
		 *
		 * The iframe is same-origin, so we read the document to confirm a page was
		 * really rendered before declaring failure; if it is unreadable we cannot tell,
		 * and the grace timeout decides.
		 *
		 * @param {string}   downloadUrl The protected download URL
		 * @param {Function} onResult    Receives true if the browser took the file
		 */
		triggerDownload: function(downloadUrl, onResult) {
			var settled = false;
			var $iframe = $('<iframe>', {
				style: 'display:none;',
				src: downloadUrl
			}).appendTo('body');

			// Teardown is scheduled independently of the verdict. Detaching a frame
			// cancels any request still in flight, so a slow file response must not be
			// aborted just because the grace period has already elapsed.
			setTimeout(function() {
				$iframe.remove();
			}, 30000);

			function settle(succeeded) {
				if (settled) {
					return;
				}
				settled = true;

				onResult(succeeded);
			}

			$iframe.on('load', function() {
				var renderedAPage = false;
				try {
					var doc = $iframe[0].contentDocument;
					renderedAPage = !!(doc && doc.body && doc.body.innerHTML.trim().length);
				} catch (err) {
					renderedAPage = false;
				}

				if (renderedAPage) {
					settle(false);
				}
			});

			setTimeout(function() {
				settle(true);
			}, 2500);
		},

		/**
		 * Show success alert bar
		 */
		showSuccessAlert: function() {
			// Use the global function if available
			if (typeof window.arivalShowDownloadAlert === 'function') {
				window.arivalShowDownloadAlert();
			} else {
				// Fallback: Try to show the alert manually
				var $alert = $('#arival-download-alert');
				if ($alert.length) {
					sessionStorage.removeItem('arival_download_alert_dismissed');
					$alert.removeClass('is-dismissing').addClass('is-visible');
				}
			}
		},

		/**
		 * Show error message
		 *
		 * @param {string} message Error message to display
		 */
		showError: function(message) {
			// Try to use WooCommerce notices if available
			if (typeof wc_add_to_cart_params !== 'undefined') {
				// Use WooCommerce's notice system
				this.showWooCommerceNotice(message, 'error');
			} else {
				// Fallback to alert
				alert(message);
			}
		},

		/**
		 * Show WooCommerce-style notice
		 *
		 * @param {string} message Notice message
		 * @param {string} type Notice type (error, success, info)
		 */
		showWooCommerceNotice: function(message, type) {
			var noticeClass = 'woocommerce-' + (type === 'error' ? 'error' : 'message');
			var $notice = $('<div class="woocommerce-notices-wrapper"><ul class="' + noticeClass + '" role="alert"><li>' + message + '</li></ul></div>');
			
			// Find a suitable container
			var $container = $('.download-main, .woocommerce-notices-wrapper, .entry-content').first();
			
			if ($container.length) {
				// Remove any existing notices
				$container.find('.woocommerce-error, .woocommerce-message').remove();
				
				// Prepend the notice
				$container.prepend($notice);
				
				// Scroll to notice
				$('html, body').animate({
					scrollTop: $notice.offset().top - 100
				}, 300);
				
				// Auto-remove after 5 seconds
				setTimeout(function() {
					$notice.fadeOut(300, function() {
						$(this).remove();
					});
				}, 5000);
			} else {
				// Fallback to alert
				alert(message);
			}
		}
	};

	/**
	 * Initialize on document ready
	 */
	$(document).ready(function() {
		FreeDownloadHandler.init();
	});

})(jQuery);

